/**
 * @module
 * @exports ready
 * @description The core dispatcher for the dom ready event javascript.
 */

import _ from 'lodash';

// you MUST do this in every module you use lodash in.
// A custom bundle of only the lodash you use will be built by babel.

import resize from './resize';
import viewportDims from './viewport-dims';

import { on, ready } from '../utils/events';

import divi from '../divi/index';
import forms from '../forms/index';
import accessibility from '../accessibility/index';

/**
 * @function bindEvents
 * @description Bind global event listeners here,
 */

const bindEvents = () => {
	on(window, 'resize', _.debounce(resize, 200, false));
};

const init = () => {
	viewportDims();

	// initialize global events

	bindEvents();
	forms();

	console.info('Initialized all javascript that targeted document ready.');
};

/**
 * @function setupEnivironment
 * @description
 */

const setupEnvironment = () => {
	init();
};


/**
 * @function domReady
 * @description Export our dom ready enabled init.
 */

const domReady = () => {
	divi();
	ready(setupEnvironment);
	accessibility();
};

export default domReady;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/core/ready.js